export enum SpinnerTypes {
    cloud = 'cloud',
    vkui = 'vkui',
    tutoria = 'tutoria',
}

export interface IProps {
    type?: SpinnerTypes;
}
